import React from 'react';
import Button from './Button';
import { errorMessageOf } from '../../utils/apiErrors';

interface LoadErrorBoxProps {
  /** What failed to load, in the user's words: "clients", "invoices". */
  what: string;
  /** The caught error (or a message). Only plain wording is shown. */
  error?: unknown;
  onRetry: () => void;
  retrying?: boolean;
}

/**
 * In-page message for a list or screen that failed to load. It stays until the
 * user retries, so a failed load never looks like an empty list.
 */
export default function LoadErrorBox({ what, error, onRetry, retrying = false }: LoadErrorBoxProps) {
  const detail = typeof error === 'string'
    ? 'Please try again.'
    : errorMessageOf(error, 'Please try again.');
  return (
    <div className="ui-load-error" role="alert">
      <div className="ui-load-error__text">
        <strong className="ui-load-error__title">Couldn't load {what}</strong>
        <span className="ui-load-error__detail">{detail}</span>
      </div>
      <Button variant="secondary" size="sm" onClick={onRetry} loading={retrying}>Retry</Button>
    </div>
  );
}
